export const API_ENDPOINTS = {
  WORKFLOW_RUN: '/v1/workflows/run',
  TABLE_DATA: '/items',
  RECIPES: '/recipes',
} as const;

export const CHAT_TYPES = {
  USER: 'user',
  AI: 'ai',
  SYSTEM: 'system',
} as const;

export const DEFAULT_PANEL_SIZES = {
  LEFT: 70,
  RIGHT: 30,
} as const;

export const TABLE_CONFIG = {
  DEFAULT_ROW_HEIGHT: 40,
  HEADER_HEIGHT: 40,
  MIN_COLUMN_WIDTH: 80,
  DEFAULT_COLUMN_WIDTH: 120,
} as const;

export const EXAMPLE_QUESTIONS = [
  '帮我生成一个去油、温和、有玫瑰香味的洗脸皂配方',
  '制作一款适合敏感肌肤的保湿面霜配方',
  '开发一个天然无硫酸盐的洗发水配方',
  '创建一个抗衰老精华液配方',
] as const;

export const MULTI_SELECT_COLORS = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', 
  '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F',
] as const;